import { useEffect, useState } from "react";
import ArrowUp from "../../../assets/icons/sidebar/upArrow.svg";
import ArrowDown from "../../../assets/icons/sidebar/downArrow.svg";
import { Link } from "react-router-dom";

const SidebarItem = ({ item, activePath, activeSubPath, navigate }) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, [activePath]);

  if (!item.visible()) return null;

  const isActive = activePath === item.path;

  return (
    <li
      className={`nav-items my-2 px-2 p-1 ${isActive && "nav-items-active"} ${
        item.subItems && open && "nav-items-dd"
      }`}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={() => {
          if (item.subItems) {
            navigate(item.subItems?.[0]?.path);
          } else {
            navigate(item.path);
          }
          setOpen(!open);
        }}
      >
        <label className="w-100 cursor_pointer">
          <item.icon fill={isActive ? "#7065E4" : "#B0B3C7"} />
          <span className="nav-text fn_Nunito fw_600">{item.label}</span>
        </label>
        {item.subItems && (
          <img
            src={open && isActive ? ArrowUp : ArrowDown}
            className="arrow-icons"
            alt="arrow"
          />
        )}
      </div>

      {item.subItems && open && isActive && (
        <ul className="nav-options my-2 ms-3">
          {item.subItems.map((sub) => (
            <Link
              to={sub.path}
              key={sub.path}
              className="text-decoration-none Medium_Purple"
            >
              <li
                className={`my-2 ${
                  activeSubPath === "/" + sub.path.split("/")[2] &&
                  "color_2ad3e7"
                }`}
              >
                <p
                  style={{ maxWidth: "100%" }}
                  className="nav-text fn_Nunito fw_600 text-truncate my-1"
                  title={sub.label}
                >
                  {sub.label}
                </p>
              </li>
            </Link>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SidebarItem;
